import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import {Observable} from 'rxjs';
import {SnackBarService} from '@core/services';
import {ACCEPTABLE_CONNECTION_TIME, NOTIFICATION_NEXT_ACTIVE_TIME, NotificationMessagesConstants} from '@core/constants';

@Injectable()
export class ConnectionInterceptor implements HttpInterceptor {
  readyToShowNotification = true;

  constructor(private _snackBarService: SnackBarService) {
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isConnectionSlow() && this.readyToShowNotification) {
      this.readyToShowNotification = false;
      this.setTimerForNextNotification();
      this._snackBarService.openSnackBar(NotificationMessagesConstants.CONNECTION_SLOW);
    }

    return next.handle(request);
  }


  isConnectionSlow(): boolean {
    const requestTime = (navigator as any)?.connection?.rtt;
    if (!requestTime) {
      return false;
    }
    return requestTime >= ACCEPTABLE_CONNECTION_TIME;
  }

  setTimerForNextNotification(): void {
    setTimeout(() => {
      this.readyToShowNotification = true;
    }, NOTIFICATION_NEXT_ACTIVE_TIME);
  }

}
